var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoBackWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_8541)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_161_8541",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5268 35.2878C21.746 35.5134 22.0076 35.6925 22.296 35.8148C22.5845 35.937 22.8942 36 23.207 36C23.5198 36 23.8295 35.937 24.118 35.8148C24.4064 35.6925 24.668 35.5134 24.8872 35.2878L25.4463 34.7161L17.0613 26.1167H37V22.857H17.0645L25.4463 14.2839L24.8872 13.7122C24.668 13.4866 24.4064 13.3075 24.118 13.1852C23.8295 13.063 23.5198 13 23.207 13C22.8942 13 22.5845 13.063 22.296 13.1852C22.0076 13.3075 21.746 13.4866 21.5268 13.7122L11 24.5L21.5268 35.2878Z",
    fill: "#E87722"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_161_8541)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_8541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48.0024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackWhite);
export default __webpack_public_path__ + "static/media/go-back-white.b4fad663885b2a3bcaa984c012ef5937.svg";
export { ForwardRef as ReactComponent };